module.exports = __webpack_public_path__ + "img/character_lineup_perspective.ad358ebc.jpg";